import {gsap} from "../../lib/gsap";

export default class BlockMarket {
	static init() {
		let blocks = document.querySelectorAll('.block-market');

		blocks.forEach( (block) => {

			const swiperMarket = block.querySelector('.slider-market');
			const swiperMarketNav = block.querySelector('.slider-market-nav');
			const followerMarket = block.querySelector('.cursor-follower');
			new Swiper(swiperMarket, {
				grabCursor: true,
				spaceBetween: 20,
				slidesPerView: "auto",
				watchOverflow: true,
				breakpoints: {
					769: {
						slidesPerView: 2
					}
				},
				navigation: {
					prevEl: swiperMarketNav.querySelector('.swiper-pill-nav-prev'),
					nextEl: swiperMarketNav.querySelector('.swiper-pill-nav-next'),
				},
				on: {
					init: (swiper) => {
						this.toggleNavigation(swiper, swiperMarket, swiperMarketNav);
					},
					resize:  (swiper) => {
						this.toggleNavigation(swiper, swiperMarket, swiperMarketNav);
					},
					update: (swiper) => {
						this.toggleNavigation(swiper, swiperMarket, swiperMarketNav);
					},
					touchStart: () => {
						gsap.to(followerMarket, 0.2, {
							scale: 0.2,
							opacity: 0
						});
					},
					touchEnd: () => {
						gsap.to(followerMarket, 0.2, {
							scale: 1,
							opacity: 1
						});
					}
				}
			});

		});
	}

	static toggleNavigation(swiper, container, navigation){
		if (swiper.slides.length <= swiper.params.slidesPerView) {
			container.closest('.cursor-follower-inner').classList.add("swiper-disabled-follower");
			navigation.style.display = 'none';
		}else{
			container.closest('.cursor-follower-inner').classList.remove("swiper-disabled-follower");
			navigation.style.display = 'inline-flex';
		}
	}

}
